import { reportFeaturesItemsLeft, reportFeaturesItemsRight } from "./constants";
import classes from "./report-features.module.scss";

export const ReportFeatures = () => {
    return (
        <div className={classes.features}>
            <h2 className={classes.features__title}>Будет проведена проверка на наличие данных:</h2>
            <div className={classes.features__columns}>
                <ul className={classes.features__list}>
                    {reportFeaturesItemsLeft.map((item, i) => (
                        <li key={i} className={classes.features__item}>
                            {item}
                        </li>
                    ))}
                </ul>
                <ul className={classes.features__list}>
                    {reportFeaturesItemsRight.map((item, i) => (
                        <li key={i} className={classes.features__item}>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};